import ApiService from '@/common/api.service'

export default {
  create (token, data) {
    return new Promise((resolve, reject) => {
      ApiService.post('/survey/create?token=' + token, data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  check (ankenId) {
    return new Promise((resolve, reject) => {
      ApiService.query(`/survey/check/${ankenId}`).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
    getSurveyInfo (token) {
        return new Promise((resolve, reject) => {
            ApiService.query('/survey/token-info', { params: { token } }).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    }
}
